import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { useDragConstraint, ObjectProps, Box, Cylinder } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Box', position: [0, 0, 0], args: [1.9, 0.2, 1] },
      { type: 'Box', position: [0, 0, 0.0175], args: [1.9075, 0.05, 1.00175] },
      { type: 'Cylinder', position: [1.03, 0, -0.4], args: [0.1, 0.1, 0.05] }
    ], 
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind}>
      <Box position={[0, 0, 0]} args={[1.9, 0.2, 1]} color="#2a2a2a" />
      <Box position={[0, 0, 0.0175]} args={[1.9075, 0.05, 1.00175]} />
      <Cylinder position={[1.03, 0, -0.4]} args={[0.1, 0.1, 0.05, 3]} rotation={[0, 0, 0]} color="#2a2a2a" />
    </group>
  );
};

